import { ReactElement, useMemo } from 'react';

import { EnhancedSetting } from '@/features/equipment-browser/subscriptions/use-get-settings-values';
import { getSourceUnits } from '@/features/equipment-browser/utils';
import { formatUnits } from '@/helpers/unit-formatter/unit-formatter';

interface SettingFieldLabelProps {
  setting: EnhancedSetting;
}

/**
 * Read-only label display component for settings.
 * Shows a label with its current value and units.
 */
export const SettingFieldLabel = ({ setting }: SettingFieldLabelProps): ReactElement => {
  const currentFormattedLabels = useMemo(() => {
    // If setting.units is not configured, assume the value is already in displayUnits
    const sourceUnits = getSourceUnits(setting);
    return formatUnits({ value: setting?.value, units: sourceUnits }, setting?.displayUnits);
  }, [setting]);

  return (
    <div className="flex flex-col gap-1">
      <label className="text-sm font-medium text-ckds-neutral-600">{setting.label}</label>
      <div className="text-sm text-ckds-neutral-900">
        {currentFormattedLabels.valueLabel}
        {currentFormattedLabels.unitsLabel && (
          <span className="ml-1 text-ckds-neutral-500">
            {currentFormattedLabels.unitsLabel.toUpperCase()}
          </span>
        )}
      </div>
    </div>
  );
};
